
export const setManualLangSwitch = value => {
  if ('localStorage' in window) {
    try {
      localStorage.setItem('isManualLangSwitch', value)
    } catch (err) {
      console.log(err)
    }
  }
}

export const getManualLangSwitch = () => {
  if ('localStorage' in window) {
    const isManualLangSwitch = localStorage.getItem('isManualLangSwitch')

    if (isManualLangSwitch) {
      try {
        return JSON.parse(isManualLangSwitch)
      } catch (err) {
        console.log(err)
      }
    } else {
      return false
    }
  }

  return false
}

export const setCustomHomePageCode = code => {
  if ('localStorage' in window) {
    try {
      localStorage.setItem('hpCode', code)
    } catch (err) {
      console.log(err)
    }
  }
}

export const getCustomHomePageCode = () => {

  if ('localStorage' in window) {
      try {
        return localStorage.getItem('hpCode')
      } catch (err) {
        console.log(err)
      }
    } else {
      return null
    }

  return null
}